// import {OpenAI} from "openai"  todo: https://dev.azure.com/BlitsBV/Blits%20Platform/_workitems/edit/3909

export enum OpenAiModel {
  "GPT 4" = "GPT 4",
  "GPT_4o" = "gpt-4o", // satisfies OpenAI.Chat.ChatModel todo: https://dev.azure.com/BlitsBV/Blits%20Platform/_workitems/edit/3909
  "GPT 3.5" = "GPT 3.5",
  // 'GPT 3.0'= 'GPT 3.0'
}

export enum OpenAIModels {
  GPT_4_LATEST = "gpt-4",
  GPT_4O_LATEST = "gpt-4o",
  GPT_4O_MINI_LATEST = "gpt-4o-mini",
  GPT_4_TURBO_LATEST = "gpt-4-turbo-latest",
  GPT_3_5_TURBO_LATEST = "gpt-3.5-turbo-latest",
}

export const OpenAIModelsEnabled = [OpenAIModels.GPT_4O_LATEST, OpenAIModels.GPT_4_LATEST, OpenAIModels.GPT_4O_MINI_LATEST]

export enum OpenAIEmbeddingsModels {
  TEXT_EMBEDDING_ADA_002 = "text-embedding-ada-002",
  TEXT_EMBEDDING_3_SMALL = "text-embedding-3-small",
  TEXT_EMBEDDING_3_LARGE = "text-embedding-3-large",
}

export const OpenAIEmbeddingsModelsEnabled = [
  OpenAIEmbeddingsModels.TEXT_EMBEDDING_ADA_002,
  OpenAIEmbeddingsModels.TEXT_EMBEDDING_3_SMALL,
  OpenAIEmbeddingsModels.TEXT_EMBEDDING_3_LARGE,
]
